<div class="container-fluid">
  <div class="row  pt-2" style="    display: flex;

  align-items: center;">

    <div class="col-md-7 w-100">
      <p class="m-0 text-uppercase" style="font-size: 20px;
  color: #237dbd;">Configuration d'Alarmes </p>

      <small class="text-uppercase" style="font-size:15px">Alarmes d'accidents </small>


    </div>


    <div class="col-md-5   w-100">
      <div class="row  px-3" style="    display: flex;
    justify-content: flex-end;">







      </div>
    </div>

  </div>


  <div class="row pt-2">
    <div class="col-sm-12 col-xl-3 col-lg-12 col-md-12 w-100 ">

      <div class="row">
        <div class="col-lg-6 col-xl-12  col-md-12 w-100 ">
          <div class="p-3 mb-2 d-flex zoomFiltrage "
            style="background: #323d415c;box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);border-radius: 6px">
            <div style="    display: flex;
            justify-content: center;" placement="bottom" ngbTooltip="Détails de l'alarme" class="col-6 col-md-3 w-100">



              <svg [ngClass]="{'disabledIcon':lengthItem != 1}" (click)="afficher_info()" width="45px" height="45px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              viewBox="0 0 395.947 395.947" style="enable-background:new 0 0 395.947 395.947;" xml:space="preserve">
           <path style="fill:#FFFFFF;" d="M349.884,81.939c-34.93-45.66-89.981-75.112-151.91-75.112C92.406,6.827,6.827,92.406,6.827,197.973
             S92.406,389.12,197.973,389.12S389.12,303.541,389.12,197.973c0-29.324-6.603-57.105-18.403-81.939"/>
           <path style="fill:#602F75;" d="M197.973,395.947C88.81,395.947,0,307.133,0,197.973S88.81,0,197.973,0
             c62.167,0,119.513,28.353,157.334,77.793c2.29,2.993,1.72,7.281-1.277,9.566c-2.983,2.301-7.277,1.734-9.569-1.273
             c-35.215-46.032-88.608-72.433-146.488-72.433c-101.634,0-184.32,82.686-184.32,184.32s82.686,184.32,184.32,184.32
             s184.32-82.686,184.32-184.32c0-27.653-5.97-54.233-17.742-79.014c-1.616-3.4-0.171-7.473,3.236-9.093
             c3.4-1.601,7.477-0.167,9.097,3.239c12.65,26.621,19.063,55.175,19.063,84.867C395.947,307.133,307.137,395.947,197.973,395.947z"/>
           <g>
             <circle style="fill:#EA3457;" cx="197.973" cy="197.973" r="116.053"/>
             <path style="fill:#EA3457;" d="M197.973,320.853c-67.756,0-122.88-55.127-122.88-122.88s55.124-122.88,122.88-122.88
               s122.88,55.127,122.88,122.88S265.73,320.853,197.973,320.853z M197.973,88.747c-60.227,0-109.227,49-109.227,109.227
               s49,109.227,109.227,109.227S307.2,258.2,307.2,197.973S258.2,88.747,197.973,88.747z"/>
           </g>
           <path style="fill:#00E7FF;" d="M40.96,204.8c-3.77,0-6.827-3.053-6.827-6.827c0-90.341,73.499-163.84,163.84-163.84
             c3.77,0,6.827,3.053,6.827,6.827c0,3.773-3.057,6.827-6.827,6.827c-82.813,0-150.187,67.374-150.187,150.187
             C47.787,201.747,44.73,204.8,40.96,204.8z"/>
           <path style="fill:#FFE600;" d="M189.897,273.954c-2.029-2.106-3.017-4.68-2.956-7.707l1.987-102.494
             c0.06-3.026,1.147-5.593,3.256-7.707c2.113-2.113,4.68-3.14,7.707-3.081c3.186,0.06,5.794,1.154,7.827,3.26
             c2.029,2.113,3.017,4.76,2.953,7.946l-1.987,102.494c-0.06,3.026-1.183,5.56-3.378,7.586c-2.19,2.033-4.799,3.014-7.827,2.953
             S191.927,276.067,189.897,273.954z M191.343,125.559c-2.343-2.441-3.483-5.333-3.417-8.68l0.017-0.954
             c0.067-3.347,1.314-6.187,3.75-8.52c2.437-2.347,5.323-3.487,8.67-3.42l1.434,0.027c3.347,0.067,6.19,1.314,8.533,3.753
             c2.343,2.427,3.48,5.313,3.413,8.66l-0.017,0.954c-0.067,3.347-1.311,6.193-3.746,8.54c-2.437,2.34-5.327,3.487-8.673,3.42
             l-1.434-0.027C196.526,129.246,193.686,127.993,191.343,125.559z"/>
           <path style="fill:#602F75;" d="M307.2,395.947h-95.573c-3.77,0-6.827-3.053-6.827-6.827s3.057-6.827,6.827-6.827H307.2
             c3.77,0,6.827,3.053,6.827,6.827S310.97,395.947,307.2,395.947z"/>
           <g>
           </g>
           <g>
           </g>
           <g>
           </g>
           <g>
           </g>
           <g>
           </g>
           <g>
           </g>
           <g>
           </g>
           <g>
           </g>
           <g>
           </g>
           <g>
           </g>
           <g>
           </g>
           <g>
           </g>
           <g>
           </g>
           <g>
           </g>
           <g>
           </g>
           </svg>


            </div>
            <div placement="bottom" ngbTooltip="Modifier l'alarme" class="col-6 col-md-3 w-100">

              <svg [ngClass]="{'disabledIcon':lengthItem != 1}" (click)="modifierAlarme()" width="45px" height="45px"
                id="Capa_1" enable-background="new 0 0 512 512" viewBox="0 0 512 512"
                xmlns="http://www.w3.org/2000/svg">
                <g>
                  <path
                    d="m427.78 482h-382.614c-8.362 0-15.166-6.804-15.166-15.166v-.239c0-8.362 6.804-15.165 15.166-15.165h176.478c24.904 0 45.165-20.262 45.165-45.166s-20.261-45.165-45.165-45.165h-94.074c-8.284 0-15 6.716-15 15s6.716 15 15 15h94.073c8.362 0 15.165 6.803 15.165 15.165s-6.803 15.166-15.165 15.166h-176.477c-24.904 0-45.166 20.26-45.166 45.165v.239c0 24.904 20.262 45.166 45.166 45.166h382.614c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
                    fill="#3ba9ff" />
                  <path
                    d="m485.52 404.5-44.04 98.62c-2.42 5.4-7.78 8.88-13.7 8.88s-11.28-3.48-13.7-8.88l-44.04-98.62 57.74-17z"
                    fill="#3ba9ff" />
                  <path d="m485.516 404.5-44.04 98.62c-2.42 5.4-7.78 8.88-13.7 8.88v-107.5z" fill="#0081ff" />
                  <path d="m512 96.32v245.68l-84.22 21.259-84.22-21.259v-245.68l84.216-16.653z" fill="#ffea80" />
                  <path d="m427.776 96.32h84.22v245.68h-84.22z" fill="#f3d332" />
                  <path
                    d="m512 342c0 2.08-.43 4.17-1.3 6.12l-25.18 56.38h-115.48l-25.18-56.38c-.87-1.95-1.3-4.04-1.3-6.12z"
                    fill="#e7f2ff" />
                  <path d="m512 342c0 2.08-.43 4.17-1.3 6.12l-25.18 56.38h-57.74v-62.5z" fill="#9dcfff" />
                  <path d="m512 84.21v12.11h-168.44v-12.11c0-46.43 37.78-84.21 84.22-84.21s84.22 37.78 84.22 84.21z"
                    fill="#ff5e94" />
                  <path d="m511.996 84.21v12.11h-84.22v-96.32c46.44 0 84.22 37.78 84.22 84.21z" fill="#ff3980" />
                </g>
              </svg>




            </div>
            <div [ngClass]="{'disabledIcon':spinnerActive == true}"  placement="bottom" ngbTooltip="Ajouter une nouvelle alarme" class="col-6 col-md-3 w-100">

              <img (click)="openDialog()" src="https://img.icons8.com/color/48/000000/expired.png"/>

            </div>







            <div placement="bottom" ngbTooltip="Supprimer l'alarme" class="col-6 col-md-3 w-100">

              <svg [ngClass]="{'disabledIcon': lengthItem == 0}" (click)="supprimerAlarme()" width="45px" height="45px"
                id="Capa_1" enable-background="new 0 0 512 512" viewBox="0 0 512 512"
                xmlns="http://www.w3.org/2000/svg">
                <g>
                  <g>
                    <path
                      d="m415.158 85.758c-.268.087-93.932 27.686-94.198 27.777-10.041 3.493-16.788 12.983-16.788 23.614v42.223c0 8.285 6.716 15.001 15.001 15.001h114.008c8.285 0 15.001-6.716 15.001-15.001v-69.935c0-17.077-16.817-29.172-33.024-23.679z"
                      fill="#ff5e94" />
                    <path
                      d="m160.161 164.371v282.624c0 35.844 29.161 65.005 65.005 65.005h158.012c35.844 0 65.005-29.161 65.005-65.005 0-15.734 0-274.731 0-282.624z"
                      fill="#9dcfff" />
                    <path d="m304.172 164.371v347.629h79.006c35.843 0 65.005-29.162 65.005-65.005v-282.624z"
                      fill="#72bbff" />
                    <g fill="#5a5a5a">
                      <path
                        d="m237.431 233.376c-8.285 0-15.001 6.716-15.001 15.001v179.616c0 8.285 6.716 15.001 15.001 15.001s15.001-6.716 15.001-15.001v-179.616c0-8.285-6.717-15.001-15.001-15.001z" />
                      <path
                        d="m304.171 233.376c-8.285 0-15.001 6.716-15.001 15.001v179.616c0 8.285 6.716 15.001 15.001 15.001s15.001-6.716 15.001-15.001v-179.616c0-8.285-6.716-15.001-15.001-15.001z" />
                    </g>
                    <g fill="#444">
                      <path
                        d="m319.172 248.381v179.613c0 8.281-6.72 15.001-15.001 15.001v-209.615c8.281 0 15.001 6.71 15.001 15.001z" />
                      <path
                        d="m370.912 233.376c-8.285 0-15.001 6.716-15.001 15.001v179.616c0 8.285 6.716 15.001 15.001 15.001s15.001-6.716 15.001-15.001v-179.616c0-8.285-6.716-15.001-15.001-15.001z" />
                    </g>
                    <path
                      d="m192.17 18.07s0 0-.01 0c-15.336-9.588-36.016-7.793-49.46 5.65v.01l-27.58 27.57-27.58 27.58c-15.6 15.6-15.6 40.98 0 56.57l14.15 14.15 20.31-2.1.9-19.12-14.14-14.14c-3.9-3.9-3.9-10.25 0-14.14l27.58-27.58 27.57-27.58h.01c3.689-3.689 10.025-4.116 14.13-.01l14.15 14.15 18.55-3.08 2.67-18.13c-14.806-14.806-16.41-16.818-21.25-19.8z"
                      fill="#5a5a5a" />
                    <path
                      d="m192.17 18.07s0 0-.01 0c-15.297-9.564-35.968-7.831-49.46 5.66l-27.58 27.57 21.22 21.22 27.58-27.58c3.686-3.686 10.017-4.124 14.13-.01l14.15 14.15 21.22-21.21c-15.291-15.291-16.162-16.574-21.25-19.8z"
                      fill="#444" />
                    <path
                      d="m317.418 37.108-26.872-26.872c-13.647-13.647-35.853-13.647-49.501 0l-166.992 166.991c-13.647 13.647-13.647 35.853 0 49.501l26.872 26.872c5.857 5.858 15.356 5.859 21.214 0l195.279-195.278c5.858-5.858 5.858-15.356 0-21.214z"
                      fill="#3ba9ff" />
                    <path
                      d="m290.545 10.236 26.872 26.872c5.855 5.855 5.862 15.352 0 21.215l-97.637 97.637-62.23-62.23 83.494-83.494c13.648-13.648 35.853-13.648 49.501 0z"
                      fill="#0081ff" />
                  </g>
                </g>
              </svg>


            </div>

          </div>

        </div>

        <div class="col-lg-6 col-xl-12  col-md-12 w-100 px-3 mb-2 ">
          <div class="row" class="px-3 py-2 mb-2 d-flex zoomFiltrage"
            style="background: #323d415c;box-shadow: 5.9px 6.8px 15.5px rgba(137, 148, 169, 0.28), -2.8px -2.8px 8px white, inset 3.5px 3.5px 6px rgba(255, 255, 255, 0.15);border-radius: 6px">
            <div class="col-2 col-md-2 w-100">
              <div style="
                cursor: pointer;
                border-radius: 7px;

                display: flex;
                justify-content: center;

              " class="py-1">
                <img (click)="exportExcel(exportDirective, 'xlsx')"
                  src="https://img.icons8.com/color/48/000000/export-excel.png" />


              </div>
            </div>
            <div class="col-6 col-md-3 w-100">
              <div style="
              cursor: pointer;
              border-radius: 7px;

              display: flex;
              justify-content: center;

                 " class="py-1">
                <img (click)="exportExcel(exportDirective, 'csv')"
                  src="https://img.icons8.com/color/48/000000/export-csv.png" />

              </div>
            </div>
            <div class="col-2 col-md-2 w-100">
              <div style="
              cursor: pointer;
              border-radius: 7px;

              display: flex;
              justify-content: center;

            " class="py-1">

                <img (click)="exportExcel(exportDirective, 'json')"
                  src="https://img.icons8.com/color/50/000000/json-download.png" />

              </div>
            </div>

            <div class="col-3 col-md-3 w-100">
              <div style="
                cursor: pointer;
                border-radius: 7px;

                display: flex;
                justify-content: center;

              " class="py-1">

                <img (click)="exportExcel(exportDirective, 'txt')"
                  src="https://img.icons8.com/color/50/000000/rich-text-converter.png" />
              </div>
            </div>
            <div class="col-2 col-md-2 w-100">
              <div style="
                cursor: pointer;
                border-radius: 7px;

                display: flex;
                justify-content: center;

              " class="py-1">
                <img (click)="exportTable()" src="https://img.icons8.com/color/48/000000/export-pdf.png" />

              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class=" col-xs-12 col-sm-12 col-lg-12 col-xl-9 col-md-12 w-100 mt-md-2">
      <div class="row ">
        <div class="col-lg-2 col-xl-2 col-md-1  w-100 ">

          <mat-form-field appearance="fill" class="widthFiltrage">
            <mat-label>Page</mat-label>
            <mat-select>

              <mat-option *ngFor="let item of collection" (click)="updateManualPage(item - 1)" [value]="item">
                {{ item }}
              </mat-option>
            </mat-select>
          </mat-form-field>

        </div>
        <div class="col-md-2 col-lg-1 d-xl-none px-0">

        </div>
        <div class="col-lg-2 col-xl-2 col-md-1  w-100 pl-0">


          <mat-form-field appearance="fill" class="widthFiltrage">
            <mat-label>Eléments</mat-label>

            <mat-select [(ngModel)]="pageSize">
              <mat-option (click)="updateManualPage2(pageSize)" *ngFor="let pageSize of pageSizeOptions"
                [value]="pageSize">
                {{ pageSize }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-lg-2 col-xl-2 col-md-2 w-100 ">

        </div>

        <div class="col-lg-5 col-xl-6 col-md-6 w-100 mb-3 d-flex">
          <mat-form-field appearance="fill" style="width: 100%; margin-bottom: 5px;">
            <mat-label>Filtrage</mat-label>
            <input matInput (keyup)="applyFilter($event)" #input>
            <mat-icon matSuffix placement="left" ngbTooltip="Chercher une ou plusieurs alarmes">search</mat-icon>
          </mat-form-field>
        </div>

      </div>
      <div style="visibility: hidden; position: fixed" [style.left]="contextMenuPosition.x"
        [style.top]="contextMenuPosition.y" [matMenuTriggerFor]="contextMenu">
      </div>
      <mat-menu #contextMenu="matMenu">
        <ng-template matMenuContent let-item="item">
          <button mat-menu-item (click)="supprimerAlarme_RightClick(item.id)"><i class="fas fa-trash-alt"></i> Supprimer
            alarme</button>
          <button mat-menu-item (click)="modifierAlarme_RightClick(item.company)"><i class="fas fa-edit"></i> Modifier
            alarme</button>


        </ng-template>
      </mat-menu>

      <div class="col-xs-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 w-100 p-0">
        <div class="example-container  mat-elevation-z8">
          <ngx-spinner *ngIf="spinnerActive != false" bdColor="rgba(100,112,124,0.56)" size="medium" color="#233547"
            type="ball-clip-rotate-multiple" [fullScreen]="false">
            <p style="color: white"> </p>
          </ngx-spinner>
          <table mat-table class="w-100" #exportDirective="matTableExporter" matTableExporter [dataSource]="dataSource"
            matSort>
            <!-- Checkbox Column -->
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef>
              </th>
              <td (click)="selection.toggle(element)" mat-cell *matCellDef="let element">
                <mat-checkbox  disabled (click)="$event.stopPropagation()"
                  (change)="$event ? selection.toggle(element) : null" [checked]="selection.isSelected(element)"
                  [aria-label]="checkboxLabel(element)" >
                </mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> ID. </th>
              <td (click)="selection.toggle(element)" mat-cell *matCellDef="let element"
                (contextmenu)="onContextMenu($event, element)"> {{element.id}} </td>
            </ng-container>

            <ng-container matColumnDef="created_by">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Nom </th>
              <td (click)="selection.toggle(element)" mat-cell *matCellDef="let element"
                (contextmenu)="onContextMenu($event, element)"> {{element.created_by}} </td>
            </ng-container>

            <ng-container matColumnDef="created_at">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Date de création </th>
              <td (click)="selection.toggle(element)" mat-cell *matCellDef="let element"
                (contextmenu)="onContextMenu($event, element)"> {{element.created_at }} </td>
            </ng-container>

            <ng-container matColumnDef="updated_at">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Date de modification </th>
              <td (click)="selection.toggle(element)" mat-cell *matCellDef="let element"
                (contextmenu)="onContextMenu($event, element)"> {{element.updated_at}} </td>
            </ng-container>
            <ng-container matColumnDef="action">
              <th mat-header-cell mat-sort-header *matHeaderCellDef>
              </th>
              <td mat-cell *matCellDef="let element"
                >
                <img (click)="afficher_info()" placement="left" ngbTooltip="Détails d'alarme" src="assets/icons/icon-details.svg"
                />
                <img (click)="modifierAlarme()" placement="left" ngbTooltip="Modifier" src="assets/icons/icon-modifier.svg"
                 />
                <img placement="left" (click)="supprimerAlarme()" ngbTooltip="Supprimer" src="assets/icons/icon-delete.svg"
                  />
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="getItem()"></tr>

 <!-- Row shown when there is no matching data. -->
 <tr class="mat-row" *matNoDataRow>
  <td class="mat-cell" colspan="12">
    Aucune donnée correspondante à votre recherche
  </td>
</tr>
          </table>
          <mat-paginator #paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25]" [showFirstLastButtons]="true">
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
